((root, factory) => {
  if (typeof module === 'object' && module.exports) {
    module.exports = factory();
    return;
  }

  root.OhanaTabbedGalleryHelpers = factory();
})(typeof globalThis !== 'undefined' ? globalThis : this, () => {
  function setActivePaginationButton(paginationButtons, activeIndex) {
    paginationButtons.forEach((button, index) => {
      const isActive = index === activeIndex;

      button.classList.toggle('is-active', isActive);

      if (isActive) {
        button.setAttribute('aria-current', 'true');
      }
      else {
        button.removeAttribute('aria-current');
      }
    });
  }

  function bindPaginationButtons({ paginationButtons, primarySlider, secondarySlider }) {
    if (!paginationButtons || !paginationButtons.length || !primarySlider) {
      return;
    }

    setActivePaginationButton(paginationButtons, primarySlider.index || 0);

    paginationButtons.forEach((button, index) => {
      button.addEventListener('click', (event) => {
        if (event && typeof event.preventDefault === 'function') {
          event.preventDefault();
        }

        primarySlider.go(index);

        if (secondarySlider) {
          secondarySlider.go(index);
        }
      });
    });

    primarySlider.on('mounted moved', (newIndex) => {
      const activeIndex = typeof newIndex === 'number' ? newIndex : primarySlider.index || 0;
      setActivePaginationButton(paginationButtons, activeIndex);
    });
  }

  return {
    bindPaginationButtons,
    setActivePaginationButton,
  };
});
